import React, {createContext, useContext, useMemo, useState} from 'react';
import D4CToolsStorage from '@components/D4CTools/D4CToolsStorage';
import type {BooleanConfigKeys, Config, ConfigKeys} from './types';
import {CONFIG_OPTIONS} from '@components/D4CTools/ToolOptions';

type D4CToolsContextType = {
	config: Config;
	setConfig: React.Dispatch<React.SetStateAction<Config>>;
};

export const D4CToolsContext = createContext<D4CToolsContextType>({
	config: D4CToolsStorage.getConfig(),
	setConfig: () => void 0,
});

type D4CToolsProviderProps = {
	children: React.ReactNode;
};

export const D4CToolsProvider = ({children}: D4CToolsProviderProps) => {
	const [d4CConfig, setD4CConfig] = useState(D4CToolsStorage.getConfig());

	const value = useMemo(() => {
		return {
			config: d4CConfig,
			setConfig: setD4CConfig,
		};
	}, [d4CConfig]);

	return (
		<D4CToolsContext.Provider value={value}>
			{children}
		</D4CToolsContext.Provider>
	);
};

export const useD4CToolsValue = <T extends ConfigKeys>(
	key: T,
): T extends BooleanConfigKeys ? boolean : string => {
	const {config} = useContext(D4CToolsContext);

	const d4cToolConfig = CONFIG_OPTIONS[key];
	const value = config[key];

	if (d4cToolConfig.type === 'boolean') {
		return JSON.parse(value);
	}

	return value as any;
};
